import { useEffect, useState } from "react";
import { db } from "../../firebase";
import { collection, getDocs } from "firebase/firestore";


const Blogs = () => {
    const [blogs, setBlogs] = useState([]);

    const fetchBlogs = async () => {
        const querySnapshot = await getDocs(collection(db, 'blogs'));
        const blogsData = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setBlogs(blogsData);
        console.log(blogs)
    }
    useEffect(() => {
        fetchBlogs();
    }, [])

    return (
        <section className="max-w-screen-xl min-h-screen m-auto p-4">
            <div>
                <h1 className="font-[blanka] dark:text-primary text-center text-2xl">Blogs</h1>
                <div className="my-10 flex gap-5 flex-col">{blogs.map((blog) => (
                    <div className="bg-white dark:text-white dark:bg-slate-600 p-5 rounded-3xl shadow-xl" key={blog.id} >
                        
                            <h3 className="text-xl font-bold">{blog.title}</h3>
                            <p className="text-lg my-2">{blog.content}</p>
                            <p className="text-xs">Posted on: {new Date(blog.createdAt?.seconds * 1000).toLocaleString()}</p>
                        

                    </div>
                ))}
                </div>
            </div>
        </section>
    )
}

export default Blogs